export const FieldSize = {
  full: 12,
  half: { xs: 12, sm: 6 },
};
